




























import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class downLoadApp extends Vue {
  userAgent: any;
  mounted() {
    this.userAgent = navigator.userAgent.toLowerCase();
  }
  closeDown() {
    this.$emit('changeDownload',false)
  }
  //下载app
  goDownLoadApp() {
    if (this.userAgent.match(/Android/i) == "android") {
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.chexun.platform";
    } else {
      //ios
      window.location.href =
        "itms-apps://apps.apple.com/cn/app/%E8%BD%A6%E8%AE%AF%E7%BD%91/id577675997";
    }
  }
}
